(function($) {
	$('.page-header .search .search-submit').on('click', function(event) {
		
		var $search = $(this).closest('.search');
		var $searchField = $search.find('.search-field');
		var $close = $search.find('.search-close');

		if ( $search.hasClass('active') ) {
			if(!$searchField.val()){
				event.preventDefault();
				$searchField.focus();
				setTimeout(function() { $close.fadeIn(); }, 300);
			}
		} else {
			event.preventDefault();
			$search.addClass('active');
			$searchField.focus();
			setTimeout(function() { $close.fadeIn(); }, 300);
		}
		
	});
	$('.page-header .search .search-close').on('click', function(event) {
		
		var $search = $(this).closest('.search');

		if ( $search.hasClass('active') ) {
			$search.removeClass('active');
			$(this).hide();
		}
		
	});

	$(document).on('click', function (event) {
		if ($(event.target).closest('.search-submit').length) {return;}
		if ($(event.target).closest('.search-field').length) {return;}

		if ( $('.page-header .search').hasClass('active') ) {
			$('.page-header .search').removeClass('active');
			$('.page-header .search .search-close').hide();
		}
	});

})(jQuery);